import React from 'react';
import PropTypes from 'prop-types';
import { convertISOToDateTimeFormat } from '../../../../util/timezone';
import { formatNumber } from '../../../../util';
import style from './index.scss';

function ThresholdValueCard({ value }) {
  if (value.length === 0) {
    return '-';
  }

  const isISODate = (val) => typeof val === 'string' && val.includes('T');

  const isNumber = (val) => typeof val === 'number' && !Number.isNaN(val);

  return (
    <div className={style.thresholdValueCard}>
      {value.map((item, index) => (
        <div key={index}>
          <div
            style={{
              // FIN-12190 — fixed label column (flexShrink:0) so the value column
              // and its left divider start at the SAME x in every row. minWidth:0 +
              // overflowWrap keep a long unbreakable label token (e.g.
              // "FailedOtpCount15m") wrapping INSIDE the column instead of crossing
              // the divider. Empty placeholder <p>s (which padded rows to 3 lines)
              // were removed so the per-row bottom border sits snug.
              width: '33%',
              flexShrink: 0,
              minWidth: 0,
              overflowWrap: 'anywhere'
            }}>
            <p style={{ margin: '0' }}>{item.key}</p>
          </div>
          <div
            style={{
              border: '1px solid #d4d4d4',
              borderRight: '0',
              borderTop: '0',
              borderBottom: '0',
              paddingLeft: '30px',
              marginLeft: '10px',
              // FIN-12190 — take the remaining width without pushing the label;
              // min-width:0 + word-break let long value tokens wrap inside this
              // column instead of stealing the label column's width.
              flex: 1,
              minWidth: 0,
              overflowWrap: 'anywhere'
            }}>
            <p style={{ margin: '0', fontWeight: 'bold' }}>
              {Array.isArray(item.value)
                ? item.value.map((m, i) => (
                    <p style={{ marginBottom: 0 }} key={`m-${i}`}>
                      {m}
                      {i !== item.value.length - 1 ? ',' : ''}
                    </p>
                  ))
                : isISODate(item.value)
                ? convertISOToDateTimeFormat(item.value)
                : isNumber(item.value)
                ? formatNumber(item.value)
                : typeof item.value === 'boolean'
                ? item.value.toString()
                : item.value}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}

ThresholdValueCard.propTypes = {
  value: PropTypes.array
};

export default ThresholdValueCard;
